import type { FieldTypeTemplate } from '#layers/data-model/types/field-types/field-type';

export function defineFieldTypeTemplate<TCommonOptions extends Record<string, any> = Record<string, any>>(type: FieldTypeTemplate<TCommonOptions>): FieldTypeTemplate<TCommonOptions> {
	return type;
}
